export default __webpack_public_path__ + "static/media/Lab Order.477254b0.svg";